(() => {
  const parseFallbacks = (value) => (value || '').split('||').map((url) => url.trim()).filter(Boolean);

  const hidePlaceholder = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.matches('[data-shopify-file-image]')) return;

    const frame = image.closest('[data-shopify-file-frame]');
    const placeholder = frame ? frame.querySelector('[data-shopify-file-placeholder]') : null;

    image.hidden = false;
    if (frame) frame.classList.remove('is-shopify-file-missing');
    if (placeholder) placeholder.hidden = true;
  };

  const showPlaceholder = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.matches('[data-shopify-file-image]')) return;

    const frame = image.closest('[data-shopify-file-frame]');
    const placeholder = frame ? frame.querySelector('[data-shopify-file-placeholder]') : null;

    image.hidden = true;
    if (frame) frame.classList.add('is-shopify-file-missing');
    if (placeholder) placeholder.hidden = false;
  };

  const tryNextFallback = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.matches('[data-shopify-file-image]')) return;

    const fallbacks = parseFallbacks(image.dataset.shopifyFileFallbacks);
    const nextImage = fallbacks.shift();

    if (nextImage) {
      image.dataset.shopifyFileFallbacks = fallbacks.join('||');
      image.src = nextImage;
      return true;
    }

    showPlaceholder(image);
    return false;
  };

  const inspectImage = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.matches('[data-shopify-file-image]')) return;

    if (image.complete && image.naturalWidth > 0) {
      hidePlaceholder(image);
    } else if (image.complete && image.naturalWidth === 0) {
      tryNextFallback(image);
    }
  };

  document.addEventListener('error', (event) => {
    tryNextFallback(event.target);
  }, true);

  document.addEventListener('load', (event) => {
    hidePlaceholder(event.target);
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-shopify-file-image]').forEach(inspectImage);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches('[data-shopify-file-image]')) inspectImage(node);
          node.querySelectorAll?.('[data-shopify-file-image]').forEach(inspectImage);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
